// import 'bootstrap/dist/css/bootstrap.min.css';
import Swal from 'sweetalert2'
import {useGlobal} from "../../contexts/GlobalContext";
import {useEffect} from "react";


export default function TellAJoke() {
    const {setJokeActive} = useGlobal()

    useEffect(showAJoke, [])

    const Popup = () => Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 6000,
        timerProgressBar: true,
        // didOpen: (toast) => {
        //     toast.addEventListener('mouseenter', Swal.stopTimer)
        //     toast.addEventListener('mouseleave', Swal.resumeTimer)
        // },

        didDestroy: () => {
            console.log('destroyed')
            setJokeActive(0)
        }
    })


    function showAJoke() {
        setJokeActive(2)
        fetch('https://official-joke-api.appspot.com/random_joke')
            .then(response => response.json())

            .then((data) => {
                    Popup().fire(
                        `${data.setup}?`,
                        `${data.punchline}`,
                        'question'
                    )
                    console.log('popup: ', Popup)

                }
            )
    }

    return <></>
}
